import React from 'react';
import FinancialTicker from './FinancialTicker';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children, showTicker = true }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {showTicker && <FinancialTicker />}
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
